import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=183eaae9&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=js&"
export * from "./NewsArticle.vue?vue&type=script&lang=js&"
import style0 from "./NewsArticle.vue?vue&type=style&index=0&id=183eaae9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183eaae9",
  null
  
)

export default component.exports